import { statsBaseline as b } from "@/config/site";

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

// Pure function (easy to test): returns the live figures for a given moment.
//  - clients / projects: baseline + 1 for every full week since the baseline date
//  - years of experience: baseline + 1 for every calendar year after the baseline year
//  - rating: fixed (kept accurate, never auto-incremented)
export const computeStats = (now = new Date()) => {
  const weeks = Math.max(0, Math.floor((now.getTime() - Date.parse(`${b.date}T00:00:00Z`)) / WEEK_MS));
  const years = b.years + Math.max(0, now.getUTCFullYear() - b.yearsBaselineYear);
  return {
    clients: b.clients + weeks,
    projects: b.projects + weeks,
    years,
    rating: b.rating,
  };
};
